// internal deps
import { IObservable, Observable } from "thrive-observable-react"

// services
import { ConversationService } from "../../service/ChatConversation.Service";
import { CS } from "../../service/Chat.Service";

//utils
import { formatToChatTime } from "../../utility/date";
import { formatPlainTextToParts } from "../../utility/Messages";

// interfaces and constants
import { missingUser } from "../../constants"
import { IMessageBody, IChatMessage,  IUser } from "../../interfaces"

class ChatMessage {
    
    public readonly id!: string
    
    private readonly senderId!: number

    private readonly sentAt!: Date

    private readonly isMe!: boolean

    private readonly previousSenderIsMe!: boolean

    private readonly isSent!: boolean

    private readonly sendingError!: boolean

    private readonly originalChatMessage!: IChatMessage

    public messageBody!: IMessageBody


    public user: IObservable<IUser> = Observable<IUser>(missingUser);
   

    constructor(message: IChatMessage, previousMessage?: IChatMessage) {
        this.id = message.id;
        this.senderId = message.senderId;
        this.sentAt = new Date(message.sentAt || message.timestamp);
        this.messageBody = message.body;
        this.isMe = CS.me.value.id === message.senderId
        this.isSent = message.isSent
        this.sendingError = message.sendingError || false;
        this.originalChatMessage = message;
        this.previousSenderIsMe = previousMessage?.senderId === this.senderId

        this.getMessageUserDetails();

        if(message.sendingError) {
            setTimeout(() => ConversationService.removeMessage(message.id), 5000);
        }
    }

    public getMessageUserDetails(): void{
        
        let user: IUser = ConversationService.getUserFromSenderId(this.senderId) as IUser;
       
        // if no user set them as default missing user
        user ??= missingUser
     
        this.user.update(user);
    }

    public getMessageSentTime() {
        return formatToChatTime(this.sentAt.toString())
    }

    public getChatCssStyle() {
        return this.isMe ? 'chat-bubble is-me' : 'chat-bubble';
    };

    public getIsSendingStyle(): string{
        return this.isSent  ? '' : 'is-sending';
    }

    public getErrorMessageStyle(): string{
        const isMeClass = this.isMe ? 'is-me' : '';
        const errorClass = this.sendingError ? 'error' : 'hide';

        return `error-message-container ${isMeClass} ${errorClass}`
    }

    public getMessageJson(){
        return this.originalChatMessage;
    }

    public formatMessageToPlainTextParts(){
        return formatPlainTextToParts(this.messageBody);
    }

    public hasProfilePic(){
        return !this.isMe && !this.previousSenderIsMe
    }
}



export {ChatMessage}